import axios from 'axios'

export default {
  // 课程标准化
  getCourses: ({ location, provinceId, grade, courseType }, config = {}) =>
    axios.get(`courses/list/1/${location}/${provinceId}/${grade}/${courseType}`, config),
  courseListAdv: ({ subject, grade, page }, config = {}) =>
    axios.get(`courseListAdv/${subject}/${grade}/${page}/`, config),
  getCourseDetail: ({ courseId, classId = 0 }, config = {}) =>
    axios.get(`detail/1/${courseId}/${classId}`, config),

  getPreSaleStatus: ({ courseId, classId, checkType }, config = {}) =>
    axios.get(`getPreSaleStatus/${courseId}${classId ? '/' + classId : ''}${checkType == 2 ? '/' + checkType : ''}`, config),
  getAddCart: (params, config = {}) => axios.post('cart/addCart', params, config), // 添加购物车
  getCartCount: (config = {}) => axios.get('cart/getCartCount', config), // 获取购物车数量
  getCouponList: (config = {}) => axios.post('coupon/list', config), // 获取劵列表
  getCoupon: (config = {}) => axios.post('coupon/get', config) // 领取券
}



// WEBPACK FOOTER //
// ./src/networks/api/NewCourseDetail/index.js